import styles from './iFrameLoginPage.module.scss';
import { Svg } from '@core/components/Svg/Svg';
import { TENANT_URL_PARAM } from '../../../tenantConfig';
import { logger } from '@shared/logger';

export const IFrameLoginPage = ({ loginClick }: { loginClick: () => void }) => {
    //get the uiKey from the params of the url t=u6eo for example
    const uiKey = new URLSearchParams(window.location.search).get(TENANT_URL_PARAM);
    logger.log('IFrameLoginPage', 1, 'uiKey:', uiKey);
    
    // Remove the preloader element once the splash screen is rendered
    const preloader = document.getElementById('preloader');
    if (preloader) preloader.remove();

    return (
        <div className={styles.page}>
            <Svg name="logo" isIcon={false} className={styles.logo} propUiKey={uiKey} />
            <button className={styles.loginButton} onClick={loginClick}>
                Login
            </button>
        </div>
    );
};
